import React, { useState } from "react";
import { Export as ExportIcon, FileDoc, FilePdf, FileText, ChatText } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { toast } from "sonner";
import { miscApi } from "@/api";

export default function ExportMenu({ pid }) {
  const [busy, setBusy] = useState(false);

  const download = async (format, variant, ext) => {
    setBusy(true);
    try {
      const resp = await miscApi.exportBlob(pid, format, variant);
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `manuscrit.${ext}`;
      a.click();
      window.URL.revokeObjectURL(url);
      toast.success("Export prêt");
    } catch (e) { toast.error("Échec de l'export"); }
    finally { setBusy(false); }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-sm gap-2" data-testid="export-menu" disabled={busy}>
          <ExportIcon size={16} /> Exporter
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-popover w-56">
        <DropdownMenuLabel>Version corrigée</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => download("docx", "corrected", "docx")} data-testid="export-docx"><FileDoc size={16} className="mr-2" /> DOCX</DropdownMenuItem>
        <DropdownMenuItem onClick={() => download("pdf", "corrected", "pdf")} data-testid="export-pdf"><FilePdf size={16} className="mr-2" /> PDF</DropdownMenuItem>
        <DropdownMenuItem onClick={() => download("txt", "corrected", "txt")} data-testid="export-txt"><FileText size={16} className="mr-2" /> TXT</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => download("commented", "corrected", "docx")} data-testid="export-commented"><ChatText size={16} className="mr-2" /> Version commentée (DOCX)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => download("docx", "original", "docx")}><FileDoc size={16} className="mr-2" /> Version originale (DOCX)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
